var isDesktop = function(){
    var BREAKPOINT_HOVER_ON_MENU_LINK = 992;

    return window.outerWidth > BREAKPOINT_HOVER_ON_MENU_LINK;
}

var MenuNode = function($context, parent) {
    var self = this;

    var BREAKPOINT_HOVER_ON_MENU_LINK = 992;

    var classMap = {
        subMenuNodeWrapper: ".js-pcg-submenu-wrapper",
        subMenuNode: ".js-pcg-submenu",
        subMenuContent: ".js-pcg-submenu-content",
        subMenuToggle: ".js-pcg-submenu-toggle",
        active: ".pcg-active",
        simple: ".pcg-menu-simple"
    };

    var $menuToggle, $menuContent;

    this.context = $context;

    var children = [];

    this.children = children;

    this.virtual = false;

    this.isActive = false;

    this.getSiblings = function (expandVirtualNodes) {
        let siblings = [];

        parent.children.forEach(sibling => {
            if(sibling != self){
                siblings.push(sibling);
            }
        });

        if(expandVirtualNodes && parent.virtual){
            parent.getSiblings(true).forEach(sibling => {
                siblings = siblings.concat(sibling.children);
            });
        }

        return siblings;
    }

    this.reset = function () {
        self.isActive = false;
        self.context.removeClass("pcg-active pcg-hidden");
        self.children
            .forEach(child => child.reset());
    }

    this.toggleHidden = function (stateVal) {
        self.context.toggleClass("pcg-hidden", stateVal);
    }

    this.toggleActive = function () {
        let isActive = self.isActive;
        self.reset();
        self.isActive = !isActive;
        self.context.toggleClass("pcg-active", self.isActive);
    }

    this.toggleSelected = function (stateVal) {

        self.context.toggleClass("pcg-selected", stateVal);
    }

    function bindEvents() {
        function toggleBehavior() {
            self.toggleActive();

            // toggle siblings
            self.getSiblings(true)
                .forEach(sibling => {
                    sibling.reset();
                    sibling.toggleHidden(self.isActive);
                });
        }

        //expand on click (tablets)
        $menuToggle.on("click", toggleBehavior);
        $menuToggle.on("keypress", function(e) {
            if (e.keyCode === 13) {
                toggleBehavior();
            }
        })
    }

    function initContext() {
        $menuToggle = $context.children(classMap.subMenuToggle).eq(0);
        $menuContent = $context.children(classMap.subMenuContent).eq(0);
        self.virtual = $menuToggle.length == 0;

        $menuContent.children(classMap.subMenuNode)
            .each(function () {
                var $childContext = $(this);

                var menuNode = new MenuNode($childContext, self); // MenuNode($context, parent)
                children.push(menuNode);
            });
    }

    function disableSimpleControls() {
        $(classMap.simple).removeClass(classMap.simple.slice(1));
    }

    function init() {
        initContext();
        disableSimpleControls();
        bindEvents();
    }

    init();
}

var MainMenu = function () {
    var $currentContext = $();

    var menuRoot;

    var classMap = {
        rootToggle: ".js-pcg-menu-root-toggle",
    };
    var $document, $rootToggle;

    function initContext() {
        $document = $(document);
        menuRoot = new MenuNode($currentContext);
        menuRoot.virtual = false;
        $rootToggle = $(classMap.rootToggle, $document);
    }

    function bindEvents() {
        //show main menu
        $rootToggle.on("click", function (e) {
            menuRoot.toggleActive();
        });

        //hide menu on click outside the menu
        $document.on("click", function(e) {
            if (!menuRoot.context.find(e.target).length && !$rootToggle.is(e.target)) {
                menuRoot.reset();
            }
        });
    }

    this.init = function ($context) {
        $currentContext = $context || $currentContext;
        initContext();
        bindEvents();
    };

    return this;
};

module.exports = MainMenu;
